import { Zap, DollarSign, Activity, Users } from 'lucide-react';
import type { FC } from 'react';
import StatCard from '@/components/common/StatCard';
import type { AiUsageStats } from '@/pages/ops/TokenWatcherPage';

interface Props {
  stats: AiUsageStats | undefined;
}

const TokenStatsCards: FC<Props> = ({ stats }) => {
  const totalCalls = stats?.byModel?.reduce((sum, m) => sum + m.apiCalls, 0) ?? 0;
  const activeUsers = stats?.topOrganizations?.reduce(
    (sum, o) => sum + (o.uniqueUsers ?? 0),
    0,
  ) ?? 0;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard
        title="Tokens Consommés"
        value={stats?.totalTokens?.toLocaleString('fr-FR') ?? '—'}
        icon={Zap}
        iconColor="text-amber-600 dark:text-amber-400"
        iconBg="bg-amber-50 dark:bg-amber-900/30"
      />
      <StatCard
        title="Coût USD"
        value={`$${Number(stats?.totalCost ?? 0).toFixed(2)}`}
        icon={DollarSign}
        iconColor="text-emerald-600 dark:text-emerald-400"
        iconBg="bg-emerald-50 dark:bg-emerald-900/30"
      />
      <StatCard
        title="Appels API"
        value={totalCalls.toLocaleString('fr-FR')}
        icon={Activity}
        iconColor="text-blue-600 dark:text-blue-400"
        iconBg="bg-blue-50 dark:bg-blue-900/30"
      />
      <StatCard
        title="Utilisateurs Actifs"
        value={activeUsers.toLocaleString('fr-FR')}
        icon={Users}
        iconColor="text-violet-600 dark:text-violet-400"
        iconBg="bg-violet-50 dark:bg-violet-900/30"
      />
    </div>
  );
};

export default TokenStatsCards;
